exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".kye-table-v2__root .virtual-header-tips {\n  line-height: 13px;\n  padding-left: 2px; }\n  .kye-table-v2__root .virtual-header-tips .tips-icon {\n    display: inline-block;\n    vertical-align: bottom;\n    width: 13px;\n    height: 13px; }\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/public/components/kye-table2/style/tips.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB,EAAE;EACpB;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,aAAa,EAAE","file":"tips.scss","sourcesContent":[".kye-table-v2__root .virtual-header-tips {\n  line-height: 13px;\n  padding-left: 2px; }\n  .kye-table-v2__root .virtual-header-tips .tips-icon {\n    display: inline-block;\n    vertical-align: bottom;\n    width: 13px;\n    height: 13px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader??ref--10-2!./node_modules/postcss-loader/lib??ref--10-3!./node_modules/fast-sass-loader/lib??ref--10-4!./src/public/components/kye-table2/style/tips.scss
// module id = OiyA
// module chunks = 7